export default __webpack_public_path__ + "static/media/Rajat_Singla.44a5832c.jpg";